const Collection = {
  Users: "users",
  Teams: "teams",
  Contents: "contents",
  Checkout: "checkout_sessions",
  Subscriptions: "subscriptions"
};

export { Collection };
